import { createBrowserRouter, RouterProvider, Navigate, redirect } from "react-router-dom";

import { App } from "../App";
import {
	WithAvatarLayout,
	Home,
	Contact,
	AboutMe,
	ErrorPage,
	WorkPage,
	CardContainer,
	ProjectPage,
} from "./pages";
import { getAllProjects, getProjectByTag, projectLoader } from "./handleProjetsData";

const useServerHashPath = () => {
	// Using a client routing, i need to redirect all page requests from the server to the root where is the app.
	// Resquested path is then add as hash on the url to apply the correct redirection here :

	const { hash } = window.location;
	if (hash) return redirect(hash.split("#").at(-1));
	return null;
};

const router = createBrowserRouter([
	{
		path: "/",
		element: <App />,
		errorElement: <ErrorPage />,
		children: [
			{
				element: <WithAvatarLayout />,
				children: [
					{
						index: true,
						loader: useServerHashPath,
						element: <Home />,
					},
					{
						path: "contact",
						element: <Contact />,
					},
					{
						path: "contact/*",
						element: <Navigate to="/contact" replace={true} />,
					},
					{
						path: "aboutme",
						element: <AboutMe />,
					},
					{
						path: "aboutme/*",
						element: <Navigate to="/aboutme" replace={true} />,
					},
				],
			},
			{
				path: "work",
				element: <WorkPage />,
				children: [
					{
						index: true,
						loader: getAllProjects,
						element: <CardContainer />,
					},
					{
						path: "about",
						element: <Navigate to="/work" replace={true} />,
					},
					{
						path: "about/:tag",
						loader: getProjectByTag,
						element: <CardContainer />,
					},
					{
						path: "about/:tag/*",
						element: <Navigate to=".." relative="path" replace={true} />,
					},
					{
						path: "*",
						element: <Navigate to="" replace={true} />,
					},
				],
			},
			{
				path: "work/:projectName",
				loader: projectLoader,
				element: <ProjectPage />,
			},
			{
				path: "work/:projectName/*",
				element: <Navigate to=".." relative="path" replace={true} />,
			},
			{
				path: "*",
				element: <Navigate to="/" replace={true} />,
			},
		],
	},
]);

const Router = () => <RouterProvider router={router} />;
export default Router;

export const resetScroll = () => window.scrollTo({ top: 0, behavior: "smooth" });
